import { stripMetadata } from "ui/StrapiImage";
import { initializeApollo } from "utils/with-apollo.utils";

import {
  SuppliedAccessoriesDataDocument,
  SuppliedAccessoriesDataQuery,
} from "./supplied-accessories-data.query.generated";
import {
  SuppliedAccessoriesSkuDocument,
  SuppliedAccessoriesSkuQuery,
} from "./supplied-accessories-sku.query.generated";

export const getSuppliedAccessoriesData = async (subscriptionSku: string) => {
  const apolloClient = initializeApollo();

  const { data: suppliedAccessoriesSkuData } =
    await apolloClient.query<SuppliedAccessoriesSkuQuery>({
      query: SuppliedAccessoriesSkuDocument,
      variables: {
        subscriptionSku,
        accessoriesTypes: ["case", "glass", "charge"],
      },
    });

  const catalogItemSkus =
    suppliedAccessoriesSkuData?.subscriptionAccessoriesSkus?.catalogItemSkus;
  const itemSkus = [
    catalogItemSkus?.case,
    catalogItemSkus?.glass,
    catalogItemSkus?.charge,
  ]
    .flat(1)
    .filter(Boolean);

  if (!itemSkus.length) {
    return null;
  }

  const { data: suppliedAccessoriesDataData } =
    await apolloClient.query<SuppliedAccessoriesDataQuery>({
      query: SuppliedAccessoriesDataDocument,
      variables: { skus: itemSkus },
    });

  return (
    suppliedAccessoriesDataData?.accessories?.data?.map(({ attributes }) => ({
      sku: attributes?.sku ?? null,
      name: attributes?.name ?? null,
      image: stripMetadata(attributes?.picture?.data?.attributes),
    })) ?? []
  );
};
